import React, { useEffect, useContext, useState } from "react";
import ProductCard from "components/Product";
import Form from 'react-bootstrap/Form';

import {
  ProductsStateContext, 
  ProductsDispatchContext,
} from "contexts/products";

import {
  CartStateContext,
  CartDispatchContext,
  toggleCartPopup
} from "contexts/cart";
import { CommonStateContext } from "contexts/common";
import Carousel from 'react-bootstrap/Carousel';
import Button from 'react-bootstrap/Button';
import { useCountdown } from 'components/Offercounter';
import { ReactVideo } from "reactjs-media";
import { FaWhatsapp } from 'react-icons/fa';
import styles from './wa-button.module.css';

const Home = () => {
  const { products, isLoading, isLoaded } = useContext(ProductsStateContext);
  // console.log(products,':::::products:::::::')
  const { searchKeyword } = useContext(CommonStateContext);
  const cartDispatch = useContext(CartDispatchContext);

  const optionValue = ['ALL ITEM','ATOM BOMBS',
  'BIJILI CRACKERS',
  'COLOUR FOUNTAINS',
  'COLOUR MATCHES',
  'DELUXE CRACKERS',
  'ELECTRIC CRACKERS',
  'FLASH SOUND CRACKER',
  'FLOWER POTS',
  'GROUND CHAKKARS',
  'GIFT BOX',
  'NIGHT SHOT SHOWER',
  'PAPER CAPS',
  'REPEATING MULTI SHOT SHOWER',
  'ROCKETS',
  'SPARKLERS',
  'TWINKLING STAR PENCIL & FANCY',
  'WALA']
  const [productSelect,setproductSelect] = useState({selectKey:'ALL ITEM'})
  // const changecheck = 0
  var productsList =
    products &&
    products.filter((product1) => {
      return (
        product1.product.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        product1.category.toLowerCase().includes(searchKeyword.toLowerCase()) || !searchKeyword
      );
    });
    if (productSelect.selectKey !== 'ALL ITEM') {
      productsList = productsList &&
          productsList.filter((product1) => {
          return (
            product1.category.toLowerCase().includes(productSelect.selectKey.toLowerCase())
          );
    });
    }
    
    // useEffect(() => {
    //   try {
  
    //     if (productSelect.selectKey !== 'ALL') {
    //       console.log(productsList,':::select',productSelect)
          
    //   }
    //     console.log(productsList,'done')
    //   }catch {
    //     console.log('error')
    //   }
      
    // },[productSelect])
  
  const  onChangeselect = (e) => {
    
    const selectKeyword = e.target.value;
    setproductSelect({ selectKey:selectKeyword})
  
    
  }
  const handleCartButton = (event) => {
    event.preventDefault();
    return toggleCartPopup(cartDispatch);
  };
  

  const handleWhatsapp = () => {
    const URL = 'https://wa.me';
    var number = "+918248192299"
    // number = number.replace(/[^\w\s]/gi, '').replace(/ /g, '');
    let url = `${URL}/${number}`;
    url += `?text=${encodeURI("Hi AkCrackershop!!!")}`;
    // console.log(url,':::::;;url')
    window.open(url);
  }
    // useEffect(() => {
  //   getProducts(dispatch,data);
  // }, []);
  const ShowCounter = ({ days, hours, minutes, seconds }) => {
    return (
      <div className="show-counter">
        <div
          // href="#"
          // target="_blank"
          // rel="noopener noreferrer"
          className="countdown-link"
        >
          
          <DateTimeDisplay value={days} type={'Days'} isDanger={days <= 3} />
          <p>:</p>
          <DateTimeDisplay value={hours} type={'Hours'} isDanger={false} />
          <p>:</p>
          <DateTimeDisplay value={minutes} type={'Mins'} isDanger={false} />
          <p>:</p>
          <DateTimeDisplay value={seconds} type={'Seconds'} isDanger={false} />
        </div>
      </div>
    );
  };
  const DateTimeDisplay = ({ value, type, isDanger }) => {
    return (
      <div className={isDanger ? 'countdown danger' : 'countdown'}>
        <p>{value}</p>
        <span>{type}</span>
      </div>
    );
  };
  const CountdownTimer = ({ targetDate }) => {
    const [days, hours, minutes, seconds] = useCountdown(targetDate);
  
    if (days + hours + minutes + seconds <= 0) {
      return <p>Offer Expired!!! ,Please wait for update</p>
    } else {
      return (
        <ShowCounter
          days={days}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
        />
      );
    }
  };
  // const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
  const date1 = new Date()  
  const date2 = new Date("09/05/2022"); 
  const THREE_DAYS_IN_MS = date2.getTime() - date1.getTime()
  const NOW_IN_MS = new Date().getTime();

  const dateTimeAfterThreeDays = NOW_IN_MS + THREE_DAYS_IN_MS;

  if (isLoading) {
    return (
      <div className="products-wrapper">
        <h1>Loading...</h1>
      </div>
    );
  }
  return (
    // <CompactTable columns={COLUMNS} data={productsList} />
    <>
    <div className="products-wrapper">
      <div className="products">
      
      <Carousel interval={3000} pause={false}>
      
      <Carousel.Item>
        <img
          className="sale"
          src="saleresize.gif"
          alt="sale"
          
        />
        
        <div
            // {...props}
            style={{
              position: 'absolute',
              left: "70%",
              top: "10%",
              zIndex: 3
             
              // ...props.style,
            }}
          >
          <img style={{width: "60%",height: "auto"}}src='source2.gif'></img>
          </div>
          <div
            // {...props}
            style={{
              position: 'absolute',
              left: "10%",
              top: "10%",
              zIndex: 3
             
              // ...props.style,
            }}
          >
          <img style={{width: "40%",height: "auto"}}src='source2.gif'></img>
          </div>

      </Carousel.Item>
      <Carousel.Item>
        <img
          className="sale"
          src="EIG1.gif"
          alt="sale"
          style = {{width:"100%",height:'150%'}}
          
        />
        
        <div
            // {...props}
            style={{
              position: 'absolute',
              left: "60%",
              top: "30%",
              zIndex: 3
             
              // ...props.style,
            }}
          >
          <img style={{width: "120%",height: "auto"}}src='gifgit.gif'></img>
          </div>
        <div
            // {...props}
            style={{
              position: 'absolute',
              left: "80%",
              top: "10%",
              zIndex: 3
             
              // ...props.style,
            }}
          >
          <img style={{width: "60%",height: "auto"}}src='R (1).gif'></img>
          </div>
          
          </Carousel.Item>
    </Carousel>
    <h3 class="blink">
      <span>Limited Stock with Genuine 50% discount Offer valid till <strong>Sep 5th</strong><br></br>  Dont miss out the wholesale price offer!!!<br></br><strong>Pre-Order Now & Pay Later</strong></span>
    </h3>
    <CountdownTimer targetDate={dateTimeAfterThreeDays} />
     
    <div style={{display:"flex"}}>
    <Form.Select  style={{borderColor: "#e23d3d",margin:"0.2%"}} aria-label="Default select example" onChange={onChangeselect}>
            {optionValue.map(id => <option value={id}>{id}</option>)}

    </Form.Select>
    <a className="cart-icon" href="#" onClick={handleCartButton}>
    <Button style={{margin:"5% 0%"}} variant="danger" size="md"><strong>Cart</strong></Button>
    </a>
      </div>
    {/* <a className="cart-icon" href="#" }> */}
          {/* </a> */}
          {/* <CartPreview /> */}
          {/* </div> */}

    
      <ProductCard data={productsList}></ProductCard>
      <h4 class="blink">
      <span>Sample Crackers Video</span>
    </h4>
      <ReactVideo
            src='https://akcrackershopapi.herokuapp.com/video'
            poster='poster.jpg'
            primaryColor="red"
            // autoPlay
        />
<div className={styles.root} onClick={handleWhatsapp}>
            <FaWhatsapp />
        </div>        
      </div>
      
    </div>
    
    </>
  );
};

export default Home;
